import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

const clientId = process.env.BUN_PUBLIC_AZURE_CLIENT_ID || '';
const tenantId = process.env.BUN_PUBLIC_AZURE_TENANT_ID || '';
const redirectUri = process.env.BUN_PUBLIC_AZURE_REDIRECT_URI || window.location.origin;

const authority = `https://login.microsoftonline.com/${tenantId}`;

const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri,
    postLogoutRedirectUri: window.location.origin,
    onRedirectNavigate: (url) => {
      if (url.includes('/logout?')) {
        // Prevent navigation to the logout URL, as we will handle logout in the application
        return false;
      }
      return true;
    },
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
